<template>
    <div>
        <eco-header :step_num="5" />
        <b-row>
            <b-col>
            </b-col>
            <b-col>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-row v-for="(item, index) of fileslist" :key="index" style="padding-top:8px">
                    <b-col :class="isMobile ? 'text-left' : 'text-right'" cols="12" md="4">
                        {{ item.title }} 
                        <a v-if="item.link != null" :href="item.link" target="blank">(подробнее)</a>
                        <strong class="text-danger" v-if="item.require"> * </strong> :
                    </b-col>
                    <b-col cols="12" md="4">
                        <template v-if="showSpinner(item.name) != true">
                            <input type="file" style="display: none"
                                @change="setFile"  
                                :id="`__step5____file_${item.name}`" 
                                :name="item.name" />
                            <b-button 
                                size="sm"
                                @click="openDialog(`__step5____file_${item.name}`)" 
                                v-if="!item.exist"
                                variant="outline-success">Выбрать</b-button>
                            <b-button 
                                size="sm"
                                @click="removeFile(item.name)" 
                                v-if="item.exist"
                                variant="outline-danger">Удалить</b-button>
                            &nbsp; <a target="blank" 
                                :href="downloadLink(item)" 
                                v-if="item.exist">{{item.source}}</a>
                            <span v-if="item.exist === false && item.require === true" class="text-danger"> * обязательно</span>
                        </template>
                        <template v-if="showSpinner(item.name) === true">
                            <b-spinner small label="Отправка файла..." variant="success"></b-spinner>
                        </template>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <eco-footer :step_num="5" :allow_next="allowNext" />
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        let spinners = {}
        for(let fl of this.$store.getters.FILESLIST ){
            spinners[fl.name] = false
        }
        return {
            spinner: spinners,
            allowNext: false,
            fileslist: []
        }
    },
    computed: {
        isMobile() { return window.innerWidth < 730 ? true : false},
    },
    methods: {
        downloadLink(item) {
            return `${window.$apiurl}/download?get=${this.$store.getters.UUID}:${item.uuid}`
        },
        showSpinner(name) {
            return this.spinner[name] && this.spinner[name] === true ? true : false
        },
        removeFile(name) {
            for(let fileItem of this.fileslist) {
                if(fileItem.name === name) {
                    fileItem.file = null
                    fileItem.source = null
                    fileItem.exist = false
                }
            }
            this.checkFiles()
        },
        openDialog(fileInputId) {
            document.getElementById(fileInputId).click()
        },
        setFile(event) {
            for(let fileItem of this.fileslist) {
                if(fileItem.name === event.target.name) {
       
                    this.spinner[fileItem.name] = true
                    let formData = new FormData()
                    formData.append('file', event.target.files[0])
                    formData.append('uuid', this.$store.getters.UUID)
                    axios.put(`${window.$apiurl}/upload`,formData,{headers:{'Content-Type': 'multipart/form-data'}})
                    .then(res => {
                        if(res.data.status === 'ok' && res.data.data.result === 'uploaded') {
                            fileItem.source = res.data.data.srcname
                            fileItem.destination = res.data.data.destname
                            fileItem.uuid = res.data.data.uuid
                            fileItem.exist = true
                        }
                        this.spinner[fileItem.name]  = false
                        this.checkFiles()
                        this.updateStore()
                    })
                    .catch(err => window.$showError(err))
                }
            }
        },
        checkFiles() {
            this.allowNext = true
            for(let item of this.fileslist){
                if(item.require === true && item.exist != true) {
                    this.allowNext = false 
                } 
            }
        },
        updateStore() {
            this.checkFiles()
            let res = []
            for(let item of this.fileslist) {
                if(item.exist === true) {
                    res.push({
                        name: item.name,
                        uuid: item.uuid,
                        source: item.source,
                        title: item.title,
                        destination: item.destination,
                    })
                }
            }
            this.$store.dispatch('SET_FILES',res)
            this.$store.dispatch('REMEMBER_COMPANY')
        }
    },
    mounted() {
        this.fileslist = this.$store.getters.FILESLIST 
        this.checkFiles()
    }
}
</script>